import { Metamodel } from 'app/model/base/model';
import { FormatReadSettings } from './format-read-settings';
import { DeltaDataset, IAttribute } from 'shell-models-lib';

@Metamodel.model({
    name: 'DeltaReadSettings',
    display: [],
    tags: { datasetModel: Metamodel.modelFor(DeltaDataset) }
})
export class DeltaFormatReadSettings extends FormatReadSettings {
    public static readonly TIMESTAMP_AS_OF: IAttribute;
    public static readonly VERSION_AS_OF: IAttribute;

    @Metamodel.attribute({
        display: stringResources.DataFlowColumnType_Timestamp,
        association: 'TIMESTAMP_AS_OF',
        templatable: true,
        accepts: ['String']
    })
    public timestampAsOf?: string;

    @Metamodel.attribute({
        display: stringResources.VersionLabel,
        association: 'VERSION_AS_OF',
        templatable: true,
        accepts: ['Int']
    })
    public versionAsOf?: number;
}
